import { Deposit } from "@entity/domain/models/deposit.model";
import { DepositFormValuesValidated } from "@entity/presentation/component/entity-form/deposits/form/deposit.form";
import { injectable } from "inversify";
import { PaymentMethodTypeEnum } from "@entity/domain/models/payment-method.model";
import { IvaExemptTypeEnum } from "@entity/domain/models/iva-exempt-type.model";
import { IrpfRetentionTypeEnum } from "@entity/domain/models/irpf-retention-type.model";

@injectable()
export class EditDepositMapper {

    mapToDeposit(deposit: DepositFormValuesValidated): Deposit {
        return new Deposit(
            deposit.id as number,
            deposit.concept,
            deposit.incomeLinkedAnotherProject,
            deposit.amount,
            deposit.name,
            deposit.depositDate?.toString() ?? "",
            deposit.paymentMethod ?? null,
            deposit.ivaExemptionType ?? null,
            deposit.irpfRetentionType ?? null,
            deposit.irpfRetentionPercentageType ?? null,
            deposit.reasonType ?? null,
            deposit.identificationType,
            deposit.identification,
            deposit.street,
            deposit.recipientIdentificationType,
            deposit.recipientIdentification,
            deposit.recipientStreet,
            deposit.financingOrganization,
            deposit.issuer ?? null,
            deposit.recipient ?? null,
            deposit.otherPaymentSource,
            deposit.expedientNumber ?? null,
            deposit.depositYear,
            deposit.tax,
            deposit.baseAmount,
            deposit.entity as number,
            deposit.relatedProject ?? undefined,
            deposit.relatedDocument ?? undefined,
            deposit.communicationDate?.toString() ?? "",
            deposit.invoiceIssueDate?.toString() ?? "",
            deposit.resolutionDate?.toString() ?? "",
            deposit.executionDate?.toString() ?? "",
            deposit.othersType,
            deposit.observations,
            deposit.attachedDocumentName ?? undefined,
            deposit.depositTypeId,
            deposit.depositSubtypeId,
            deposit.depositCategoryId,
            deposit.depositScopeId,
            deposit.scopeDetail,
        );
    }
}
